var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"transparent-btn",attrs:{"icon":""},on:{"click":_vm.printDocument}},[_c('i',{staticClass:"fa fa-print mr-2 text-success"}),_vm._v(_vm._s(_vm.language_terms['PRINT'])+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }